var exports = {
  "U": "traceTable__owswtc",
};

module.exports = exports;
